import { useCustomSWR } from 'utils/hooks/fetchers'

export const useArticleById = (id) => {
  return useCustomSWR(id && `/articles/${id}`)
}
